module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point05_01_sunset-651389db14dfb6983af99a5e9d364f3e.jpg";